const demo_app = {
    notification: 'Wskazówka: Najpierw stwórz konto, aby przetestować proces logowania.',
};
export default demo_app;
